// Mirrors Akcelita.UWE.Core.Common.Enums.FormVersionStatus. No JsonStringEnumConverter is
// configured on the backend, so these come across the wire as plain integers, not strings.
export const FormVersionStatus = {
  Draft: 0,
  Scheduled: 1,
  Active: 2,
  Superseded: 3,
} as const;

export type FormVersionStatus = (typeof FormVersionStatus)[keyof typeof FormVersionStatus];

export const FORM_VERSION_STATUS_LABEL: Record<FormVersionStatus, string> = {
  [FormVersionStatus.Draft]: 'Draft',
  [FormVersionStatus.Scheduled]: 'Scheduled',
  [FormVersionStatus.Active]: 'Active',
  [FormVersionStatus.Superseded]: 'Superseded',
};

// Shape of a FormVersionDTO row, as returned by FormApi.getVersions/getVersion.
export interface FormVersion {
  id: number;
  version: number;
  status: FormVersionStatus;
  activationDateUtc: string | null;
}

// Full FormVersionDTO document returned by FormApi.getVersion (FormApi.getVersions only returns
// the list-row shape above). Content fields are loosely typed since they're schema-driven — same
// treatment as FormLike in MigrateToV2Modal.tsx.
export interface FormVersionDocument extends FormVersion {
  name: string;
  title: string;
  commentFieldsMap: Record<string, unknown>;
  sendBack: Record<string, unknown>;
  options: Record<string, unknown>;
  schema: Record<string, unknown>;
  uiSchema: Record<string, unknown>;
  objectMap: Record<string, unknown>;
  permissionsMap: Record<string, unknown>;
  sidebarComponents: unknown;
  lastUpdated: string;
}

// The only fields compared when diffing two form versions against each other. Deliberately
// excludes id/formId/version/status/activationDateUtc — those trivially differ between any two
// versions (or aren't even present on both sides: a live-edited Draft has no version/status/
// activationDateUtc at all, unlike a version fetched via getVersion) and would just be noise.
export const FORM_VERSION_COMPARE_FIELDS = [
  'name',
  'title',
  'commentFieldsMap',
  'sendBack',
  'options',
  'schema',
  'uiSchema',
  'objectMap',
  'permissionsMap',
  'sidebarComponents',
  'lastUpdated',
] as const;
